import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FacebookIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.9998 12.0327C20.9998 7.06219 16.9703 3.03271 11.9998 3.03271C7.0293 3.03271 2.99982 7.06219 2.99982 12.0327C2.99982 16.2534 5.90574 19.795 9.82578 20.7678V14.7831H7.96998V12.0327H9.82578V10.8476C9.82578 7.78436 11.2121 6.36452 14.2196 6.36452C14.7898 6.36452 15.7737 6.47648 16.1762 6.58808V9.08108C15.9638 9.05876 15.5948 9.0476 15.1365 9.0476C13.6609 9.0476 13.0906 9.60668 13.0906 11.06V12.0327H16.0304L15.5253 14.7831H13.0906V20.9668C17.5471 20.4286 21.0002 16.6342 21.0002 12.0327H20.9998Z" />
    </SvgIcon>
  );
});
